/* Storage có thể ném ngay ở bước đọc (Safari private, cookie bị chặn, iframe
   sandbox). Bọc một lớp trả về null thay vì nổ, và tự rơi về bộ nhớ RAM để
   widget vẫn chạy trong phiên hiện tại.

   Mặc định là sessionStorage; lịch sử chính do server quản lý. */

const memory = new Map<string, string>();
const probed = new Map<string, boolean>();

export type Area = "session" | "local";

function pick(area: Area): Storage | null {
  const key = area;
  const cached = probed.get(key);
  try {
    const store = area === "local" ? window.localStorage : window.sessionStorage;
    if (cached === false) return null;
    if (cached === undefined) {
      const probe = "__apx_probe__";
      store.setItem(probe, "1");
      store.removeItem(probe);
      probed.set(key, true);
    }
    return store;
  } catch {
    probed.set(key, false);
    return null;
  }
}

export function getItem(key: string, area: Area = "session"): string | null {
  const store = pick(area);
  if (store) {
    try {
      return store.getItem(key);
    } catch {
      /* rơi xuống bộ nhớ RAM */
    }
  }
  return memory.has(key) ? (memory.get(key) as string) : null;
}

export function setItem(key: string, value: string, area: Area = "session"): void {
  memory.set(key, value);
  const store = pick(area);
  if (!store) return;
  try {
    store.setItem(key, value);
  } catch {
    /* hết quota hoặc bị chặn — bản RAM ở trên đủ cho phiên này */
  }
}

export function removeItem(key: string, area: Area = "session"): void {
  memory.delete(key);
  const store = pick(area);
  if (!store) return;
  try {
    store.removeItem(key);
  } catch {
    /* ignore */
  }
}

export function getJSON<T>(key: string, area: Area = "session"): T | null {
  const raw = getItem(key, area);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as T;
  } catch {
    removeItem(key, area);
    return null;
  }
}

export function setJSON(key: string, value: unknown, area: Area = "session"): void {
  try {
    setItem(key, JSON.stringify(value), area);
  } catch {
    /* giá trị có vòng lặp tham chiếu — bỏ qua, không đáng để nổ */
  }
}
